import styled, { css } from 'styled-components'

import Text from '@/ui/Text'

interface PersonWrapperProps {
  onClick?: () => void
}

interface ProfileImageProps {
  small: boolean
}

interface NameProps {
  light?: boolean
  title?: string
}

interface EmailProps {
  light?: boolean
  title?: string
}

export const PersonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 0;
  cursor: ${({ onClick }: PersonWrapperProps) =>
    onClick ? 'pointer' : 'inherit'};
`

export const InfoWrapper = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`

export const ProfileImage = styled(({ small, name, ...rest }) => (
  <img alt={name} {...rest} />
))`
  ${({ small }: ProfileImageProps) => css`
    width: ${small ? 20 : 36}px;
    height: ${small ? 20 : 36}px;
    object-fit: cover;
    border-radius: 100%;
  `}
`

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  overflow: hidden;
  margin-left: 12px;
`

export const Name = styled(Text.Span)<NameProps>`
  display: block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const Email = styled(Text.Span).attrs({
  light: true,
})<EmailProps>`
  display: block;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const PersonListWrapper = styled.div`
  ${PersonWrapper}:not(:last-child) {
    margin-bottom: 12px;
  }
`

export const Extra = styled.div``
